import { cryptoRandom } from '@app/shared/utils/utils';

export function generateId(): string {
  // Math.random should be unique because of its seeding algorithm.
  // Convert it to base 36 (numbers + letters), and grab the first 9 characters
  // after the decimal.
  return '_' + cryptoRandom().toString(36).substring(2, 9);
}
